import React from "react";
import { withRouteData, Link } from "react-static";
import { Helmet } from "react-helmet";
import Img from "react-image";
import { MoonLoader } from "react-spinners";
import Thumbnail from "../components/thumbnail.js";

//

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: false
    };
  }
  render() {
    const { posts } = this.props;
    const sorted = posts.sort((first, second) => {
      return (
        new Date(second.data.date).getTime() -
        new Date(first.data.date).getTime()
      );
    });
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>soju.studio</title>
          <link rel="canonical" href="https://soju.studio" />
        </Helmet>
        <table>
          <tbody>
            <tr>
              <td>projects</td>
              <td />
              <td>category</td>
              <td>year</td>
            </tr>
            <tr className="tablespacing" />
            {sorted.map(post => (
              <tr key={post.data.slug} className="project">
                <td className="mix-blend">
                  <Link to={`/${post.data.slug}`}>
                    <span>{post.data.title}</span>
                  </Link>
                </td>
                <td>
                  <Link to={`/${post.data.slug}`}>
                    <Thumbnail
                      className="thumbnail"
                      src={post.data.thumbnail}
                      key={post.data.slug}
                    />
                  </Link>
                </td>
                <td className="mix-blend">
                  <Link to={`/${post.data.slug}`}>
                    <span>{post.data.category}</span>
                  </Link>
                </td>
                <td className="mix-blend">
                  <Link to={`/${post.data.slug}`}>
                    <span>{post.data.date.slice(0, 4)}</span>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="mobile">
          {sorted.map(post => (
            <div className="mobile-project" key={post.data.slug}>
              <br />
              <Link to={`/${post.data.slug}`}>
                <p className="mobile-title">
                  <span>{post.data.title}</span> {post.data.date.slice(0, 4)}
                </p>
                <div
                  style={{
                    minHeight: "200px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Img
                    src={post.data.thumbnailmobile}
                    loader={<MoonLoader color="#fff" size={20} />}
                  />
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default withRouteData(({ posts }) => <Home posts={posts} />);



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Home.js